import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import get from 'lodash/get';

import ErrorBlock from '../common/ErrorBlock';
import Loader from '../common/Loader';
import { actions as signupActions } from '../../redux/auth/signup/signup-req';
import { actions as logoutActions } from '../../redux/auth/logout';
import { AUTH } from '../../constants/strings';
import { EXPIRED_TOKEN } from '../../constants/routes';

const mapStateToProps = (state, ownProps) => ({
  logout: state.auth.logout,
  status: state.auth.status,
  signup: state.auth.signup,
  token: ownProps.routeParams.token,
});

const mapDispatchToProps = {
  acceptInvitation: signupActions.send,
  logoutAction: logoutActions.send,
};

@injectIntl
@connect(
  mapStateToProps,
  mapDispatchToProps,
)
export default class Registration extends Component {
  shouldComponentUpdate(nextProps) {
    const signupSucceed =
      nextProps.signup.succeed && !get(this.props, 'signup.succeed');
    const signupRejected =
      nextProps.signup.rejected && !get(this.props, 'signup.rejected');

    const logoutSucceed =
      nextProps.logout.succeed && !get(this.props, 'logout.succeed');
    const logoutRejected =
      nextProps.logout.rejected && !get(this.props, 'logout.rejected');

    return signupSucceed || signupRejected || logoutSucceed || logoutRejected;
  }

  render() {
    const {
      status: { loggedIn, redirectTo },
      signup,
      logout,
      token,
      acceptInvitation,
      logoutAction,
      intl: { formatMessage },
    } = this.props;

    // error handling
    if (signup.rejected) {
      browserHistory.push(EXPIRED_TOKEN);
      return <Loader />;
    }

    if (logout.rejected) {
      return (
        <ErrorBlock
          errors={formatMessage(AUTH.errors.common)}
          className="mb3"
        />
      );
    }

    // second render
    if (signup.succeed && redirectTo) {
      browserHistory.push(`/${redirectTo}`);
      return <Loader />;
    }

    // first + render
    if (logout.succeed) {
      acceptInvitation({ token });
      return <Loader />;
    }

    // first render
    if (loggedIn) {
      logoutAction();
    } else {
      acceptInvitation({ token });
    }

    return <Loader />;
  }
}

Registration.propTypes = {
  logout: PropTypes.shape({
    rejected: PropTypes.bool,
    succeed: PropTypes.bool,
  }),
  status: PropTypes.shape({
    loggedIn: PropTypes.bool,
    redirectTo: PropTypes.string,
  }),
  signup: PropTypes.shape({
    rejected: PropTypes.bool,
    succeed: PropTypes.bool,
  }),
  token: PropTypes.string,
  acceptInvitation: PropTypes.func,
  logoutAction: PropTypes.func,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
};



// WEBPACK FOOTER //
// ./src/components/Auth/Registration.jsx